import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";

import InlineCheckbox from "@toolbox/button-like/InlineCheckbox";
import T, {intl2Str} from "@translate/T";

interface IPasswordPanelProps {
    password: string;
    mustChange?: boolean;
    canChange?: boolean;
    onChange(password: string): void;
}

interface IPasswordPanelStates {
    showPassword: boolean;
    changePassword: boolean;
}

class PasswordPanel extends React.PureComponent<
    IPasswordPanelProps,
    IPasswordPanelStates
> {
    public readonly state: IPasswordPanelStates = {
        changePassword: false,
        showPassword: false,
    };

    @boundMethod
    public onPasswordChanged(e: React.ChangeEvent<HTMLInputElement>) {
        e.preventDefault();

        this.props.onChange(e.target.value);
    }

    @boundMethod
    public toggleChangePassword(checked: boolean) {
        this.setState({changePassword: checked}, () => {
            if (!this.state.changePassword) {
                this.props.onChange("");
            }
        });
    }

    @boundMethod
    public toggleShowPassword(e: React.SyntheticEvent) {
        e.preventDefault();

        this.setState({showPassword: !this.state.showPassword});
    }

    public render() {
        return (
            <div className="mb-2">
                {this.renderCheckbox()}
                {this.renderNewPassword()}
            </div>
        );
    }

    private renderCheckbox() {
        const {mustChange, canChange} = this.props;
        if (mustChange) {
            return null;
        }

        return (
            <InlineCheckbox
                idSuffix="change-password"
                disabled={!canChange}
                title={
                    !canChange
                        ? (intl) => intl2Str(intl, "Insufficient rights!")
                        : undefined
                }
                checked={this.state.changePassword}
                toggle={this.toggleChangePassword}
            >
                <T>Change password</T>
            </InlineCheckbox>
        );
    }

    private renderNewPassword() {
        const {changePassword, showPassword} = this.state;
        const {mustChange, password} = this.props;
        if (!mustChange && !changePassword) {
            return null;
        }

        return (
            <div>
                <label className="mb-1" htmlFor="password">
                    <T>New password</T>
                </label>
                <div className="input-group">
                    <input
                        type={!showPassword ? "password" : "text"}
                        id="password"
                        className="form-control"
                        autoComplete="new-password"
                        required={true}
                        value={password}
                        onChange={this.onPasswordChanged}
                    />
                    <span className="input-group-append">
                        <button
                            type="button"
                            id="toggle-show-password"
                            className="btn btn-secondary rounded-right"
                            onClick={this.toggleShowPassword}
                        >
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                fixedWidth={true}
                            />
                        </button>
                    </span>
                    <div className="invalid-feedback">
                        <T>Password is required!</T>
                    </div>
                </div>
            </div>
        );
    }
}

export default PasswordPanel;
